module.exports = __webpack_public_path__ + "img/m-hd.b51bf49c.jpg";